(ns manage.ad-variant.creation.link.hooks
  (:require [common.queries :refer [use-query]]
            [manage.ad-variant.creation.link.queries :as q]
            [uix.core :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(defhook use-os-data []
  (let [os-enabled? (use-subscribe [:common.os/enabled])
        token (use-subscribe [:common.os/token])
        project-id (use-subscribe [:common.os/project-id])
        workspace-id (use-subscribe [:common.os/workspace-id])
        tenant-id (use-subscribe [:common.os/tenant-id])]
    {:os-enabled os-enabled?
     :token token
     :project-id project-id
     :workspace-id workspace-id
     :tenant-id tenant-id}))

(defhook use-ps-campaigns []
  (let [os-enabled? (use-subscribe [:common.os/enabled])
        {:keys [adset-id] :as url-context} (use-subscribe [:url-context])
        token (use-subscribe [:common.os/token])
        project-id (use-subscribe [:common.os/project-id])
        workspace-id (use-subscribe [:common.os/workspace-id])
        tenant-id (use-subscribe [:common.os/tenant-id])
        {:keys [status data refetch]} (use-query (q/available-third-party-projects
                                                  url-context project-id workspace-id tenant-id token os-enabled?))
        ;; Extract meta field for PS status (ps-not-ready, ps-unavailable, ok)
        {:keys [meta]} data
        ps-status (keyword (get meta :status "ok"))
        ps-message (get meta :message)

        {:keys [campaigns mapped-campaigns]} (:data data)
        mapped-to-current-adset-ids (->> mapped-campaigns
                                         (filter #(= (second %) adset-id))
                                         keys (map name) set)
        mapped-to-other-adsets (->> mapped-campaigns
                                    (remove #(or (= (second %) adset-id) (= (second %) nil)))
                                    keys (map name) set)
        mapped-to-current-adset (->> campaigns
                                     (filter #(some? (mapped-to-current-adset-ids (:id %)))))
        sorted-campaigns (->> campaigns
                              (map #(assoc % :disabled (contains? mapped-to-other-adsets (:id %))))
                              (sort-by :disabled))]
    {:status status
     :ps-status ps-status
     :ps-message ps-message
     :campaigns sorted-campaigns
     :mapped-campaigns-ids mapped-to-current-adset-ids
     :mapped-campaigns mapped-to-current-adset
     :project-id project-id
     :refetch-available-third-party-projects refetch}))
